import { useState } from "react";
import "./Headshots.css";

const images = [
  "./IMG_0838.jpg",
  "./IMG_0841.jpg",
  "./IMG_0842.jpg",
  "./IMG_0843.jpg",
  "./IMG_0844.jpg",
  "./IMG_0845.jpg",
  "./IMG_0846.jpg",
  "./IMG_0849.jpg",
  "./IMG_0850.jpg",
  "./IMG_0851.jpg",
  "./IMG_0852.jpg",
  "./IMG_0853.jpg",
];

export default function Headshots() {
  const [focused, setFocused] = useState(null);

  return (
    <div className="headshots-container">
      {images.map((src, index) => (
        <div
          key={index}
          className={`headshot ${focused === index ? "focused" : ""}`}
          onClick={() => setFocused(index)}
        >
          <img src={src} alt={`Headshot ${index + 1}`} />
        </div>
      ))}
    </div>
  );
}
